<template>
  <b-navbar toggleable="md" type="dark" variant="dark" :sticky="true">
    <b-navbar-toggle target="nav_collapse"/>
    <b-navbar-brand class="navbar_brand_opt" href="#">SLC-LAS</b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <tradeknight-menu v-if="agentMenu || sellerMenu" :agentMenu="agentMenu" :sellerMenu="sellerMenu" :enableTool="enableTool"/>
      <exchange-rate v-if="agentMenu || sellerMenu"/>
      <!-- <trouble-product-warning v-show="sellerMenu && depositWarn"/> -->
      <deposit-warning v-show="sellerMenu=='1' || depositWarn=='1'" :isWarnDeposit="isWarnDeposit" :troubleProductWarn="troubleProductWarn" :isWarnShippingStop="isWarnShippingStop"/>
      <account-menu v-if="agentMenu || sellerMenu"/>
    </b-collapse>
  </b-navbar>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import TradeknightMenu from '@/components/navigation/TradeknightMenu';
import ExchangeRate from '@/components/navigation/ExchangeRate';
import DepositWarning from '@/components/navigation/DepositWarning';
import TroubleProductWarning from '@/components/navigation/TroubleProductWarning';
import AccountMenu from '@/components/navigation/AccountMenu';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      agentMenu: false,
      sellerMenu: false,
      enableTool: false,
      isWarnDeposit: false,
      isWarnShippingStop: false,
      troubleProductWarn: false
    };
  },
  methods: {
    updateView() {
      this.agentMenu = (utility.isAgent(this.$store.state.role) || utility.isAdmin(this.$store.state.role));
      this.sellerMenu = (utility.isSeller(this.$store.state.role) || utility.isAdmin(this.$store.state.role));
      this.enableTool = utility.isAdmin(this.$store.state.role);
      this.isWarnDeposit = this.$store.state.isWarnDeposit;
      this.isWarnShippingStop = this.$store.state.isWarnShippingStop;
      this.troubleProductWarn = utility.isLoginCheckWarn(this.$store.state.troubleProductWarn);
      // console.log("aaa: " + this.isWarnDeposit + "/" + this.isWarnShippingStop);
    }
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
  },
  watch: {
    token (newToken) {
      this.updateView();
    }
  }
};

Vue.component('tradeknight-menu', TradeknightMenu);
Vue.component('exchange-rate', ExchangeRate);
Vue.component('deposit-warning', DepositWarning);
Vue.component('trouble-product-warning', TroubleProductWarning);
Vue.component('account-menu', AccountMenu);
</script>

<style scoped>
.gray-dark {
  background-color: #343a40;
  color: hsla(0, 0%, 100%, .5);
}
.active {
  color: white;
}
</style>

<style>
nav.navbar {
  padding: 0rem 1rem;
}
.navbar_brand_opt{
  margin-right: 2rem;
}
.navbar-toggler {
  padding: 0rem 0rem!important;
}
.dropdown-menu {
  padding-top: 0px;
  padding-bottom: 0px;
}
.dropdown-item:hover {
  color: whitesmoke;
}
</style>